import React, { useState } from "react";
import KickImage from 'Reuseables/KickImage';
import { withRouter } from "react-router-dom"
import { Collapse } from "reactstrap"

/* COMPONENTS */
import OrderDetails from "./OrderDetails"

/* ASSETS */
import SuccessIcon from "../../../../images/kick-credit-payment-success.jpg";
import InfoIcon from "../../../../images/info1024.png";
import ArrowDown from '../../../../images/arrowDown.png';

const SuccessResult = ({
  invoice_number,
  history,
  orderDetailsData
}) => {
  const handleGoToBuyingDashboard = (value) => {
    const params = {
      pathname: '/user_dashboard/order',
      state: { tabs: value }
    }
    history.push(params)
  }

  const [isOpenCollapse, setIsOpenCollapse] = useState(false)

  const {
    payment,
    product,
    addonProduct,
    sell
  } = orderDetailsData

  return (
    <div className="success-payment-wrapper">
      <div className="result-text-wrapper">
        <p>Hooray! You have successfully purchased!</p>
        <p>Be patient to hear “knock knock” on your door! Your orders are just a few step away.</p>
        {
          window.innerWidth <= 768 ?
            <div className="collapse-order-id">
              <p>
                ORD ID <u onClick={() => handleGoToBuyingDashboard("Pending")}>{invoice_number}</u>
              </p>
              <KickImage onClick={() => setIsOpenCollapse(!isOpenCollapse)} src={ArrowDown} alt="..." />
            </div>
            :
            <p>ORD ID <u onClick={() => handleGoToBuyingDashboard("In Progress")}>{invoice_number}</u></p>
        }
        {window.innerWidth <= 768 &&
          <Collapse isOpen={isOpenCollapse}>
            <OrderDetails
              payment={payment}
              product={product}
              addonProduct={addonProduct}
              sell={sell}
            />
          </Collapse>
        }
      </div>
      <div className="icon-wrapper">
        <KickImage src={SuccessIcon} alt="Success!" />
      </div>
      <div className="info-wrapper">
        <div className="info-icon-wrapper">
          <KickImage src={InfoIcon} alt="Info icon" />
        </div>
        <div className="text-wrapper">
          <p>Please allow 3-7 business days to allow the seller ship your purchase to our facility. Every purchase will be shipped to Kick Avenue to be authenticated and guaranteed. We will refund your payment if the product is proven to be fake.</p>
        </div>
      </div>
      <div className="button-wrapper">
        <div className="button"
          onClick={() => history.replace("/")}
        >
          <p>Continue Shopping</p>
        </div>
        <div className="button"
          onClick={() => handleGoToBuyingDashboard("In Progress")}
        >
          <p>Go to Buying Dashboard</p>
        </div>
      </div>
    </div>
  )
}

export default withRouter(SuccessResult)